import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";


@Injectable()
export class MasterService {
  constructor(private dataService: DataService,
    private activatedRoute: ActivatedRoute,

  ) {
  }
  url = environment.api_base_url;
  authUrl = environment.api_base_url;


  getTvRegions(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/tvregion").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getNfrnRegion(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/nfrnregion").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getMenu(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.authUrl + "auth/menu").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getMenuDescription(route: string): Observable<any> {
    let data = this.activatedRoute;
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.authUrl + "auth/menu/route?route=" + route).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }


}